import * as React from "react";

import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const textareaVariants = cva(
  "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base text-foreground ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
  {
    variants: {
      variant: {
        default: "bg-background",
        secondary: "bg-gray-dark-600",
        transparent:
          "bg-black border-none focus-visible:ring-0 focus-visible:ring-offset-0 text-foreground"
      },
      size: {
        default: "px-3 py-[10px] min-h-[80px] h-auto",
        sm: "py-2 min-h-[72px] h-auto",
        xs: "py-[6px] min-h-[64px] h-auto"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);

export type TextareaProps = VariantProps<typeof textareaVariants> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    invalid?: boolean;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ variant, size, className, invalid, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          invalid ? "!border-red-dark-400" : "!border-gray-dark-200",
          textareaVariants({ variant, size, className })
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
